import { childServingRatio } from '../constants';
import { MealPlanPreferenceName } from '../components/choose-meal-plan';
import { MealPlanPreference } from '../models';

export function mapHouseholdToServings(householdPreference: MealPlanPreference | undefined): number {
	const preferenceValue = householdPreference?.value as { [key: string]: number } | undefined;
	return !preferenceValue ? 0 : preferenceValue.adult + preferenceValue.child * childServingRatio;
}

export function getHouseholdPreference(preferences: MealPlanPreference[]): MealPlanPreference | undefined {
	return preferences.find((preference: MealPlanPreference) => preference.name === MealPlanPreferenceName.people);
}
